import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages";
import { ChatSection } from "./pages/chat";

const AppWithNavigation = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<Home />}
        children={[
          <Route element={<ChatSection />} key="chat-page" index={true} />,
        ]}
      />
      <Route
        path="/:provider"
        element={<Home />}
        children={[
          <Route
            element={<ChatSection />}
            key="provider-chat-page"
            index={true}
          />,
        ]}
      />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter basename="/energygpt/">
      <AppWithNavigation />
    </BrowserRouter>
  );
}

export default App;
